import { TextField, TextFieldProps } from '@mui/material';
import { FC } from 'react';

import { Controller } from 'react-hook-form';
import FieldGridContainer from '../fieldGridContainer';

export type ControlledTextFieldProps = TextFieldProps & {
  control?: any;
  isGridItem?: boolean;
  label: string;
  id: string;
  name: string;
  errorMessage?: string;
  isFullWidth?: boolean;
  dataTestId?: string;
};

const ControlledTextField: FC<ControlledTextFieldProps> = (
  props: ControlledTextFieldProps
) => {
  const {
    control,
    isGridItem = true,
    label,
    id,
    name,
    helperText = '',
    errorMessage,
    isFullWidth = true,
    dataTestId = 'text-field-container',
    sx,
    ...otherProps
  } = props;

  const getTextField = () => {
    return (
      <Controller
        name={name ?? ''}
        control={control}
        render={({ field }) => {
          const { ref, value, ...fieldProps } = field;
          const {
            onChange,
            onBlur,
            value: otherValue,
            ...restOtherProps
          } = otherProps;

          return (
            <TextField
              {...fieldProps}
              {...restOtherProps}
              inputRef={ref}
              id={id}
              label={label}
              size="small"
              fullWidth
              helperText={errorMessage ?? helperText}
              error={!!errorMessage}
              value={value ?? ''}
              data-testid={dataTestId || `text-field-${id}`}
              sx={{
                '& .MuiInputBase-root': {
                  minHeight: {
                    xs: '44px',
                    sm: '40px',
                  },
                  fontSize: {
                    xs: '16px', // Prevents zoom on iOS
                    sm: '14px',
                  },
                },
                '& .MuiInputLabel-root': {
                  fontSize: {
                    xs: '0.875rem',
                    sm: '1rem',
                  },
                },
                ...sx,
              }}
            />
          );
        }}
      />
    );
  };

  if (isGridItem) {
    return (
      <FieldGridContainer isFullWidth={isFullWidth} dataTestId={dataTestId || `text-field-container-${id}`}>
        {getTextField()}
      </FieldGridContainer>
    );
  }

  return <div data-testid={dataTestId || `text-field-container-${id}`}>{getTextField()}</div>;
};

export default ControlledTextField;
